const VIMEO_PLAYER_PARAMS =
  'title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479';

const VIMEO_TEXT_PATTERN = /^\s*vimeo:\s*(\d+)\s*$/i;

export function createVimeoEmbedElement(vimeoId: string): HTMLDivElement {
  const wrapper = document.createElement('div');
  wrapper.className = 'vimeo-embed-wrapper';

  const iframe = document.createElement('iframe');
  iframe.src = `https://player.vimeo.com/video/${vimeoId}?${VIMEO_PLAYER_PARAMS}`;
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute(
    'allow',
    'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
  );
  iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
  iframe.setAttribute('title', `Vimeo video ${vimeoId}`);

  wrapper.appendChild(iframe);
  return wrapper;
}

function replaceMarkerWithEmbed(marker: HTMLElement, vimeoId: string | null) {
  if (!vimeoId || !/^\d+$/.test(vimeoId)) {
    return;
  }

  marker.replaceWith(createVimeoEmbedElement(vimeoId));
}

function transformVimeoTextNodes(root: ParentNode) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  let currentNode = walker.nextNode();
  while (currentNode) {
    textNodes.push(currentNode as Text);
    currentNode = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    const match = (textNode.textContent || '').match(VIMEO_TEXT_PATTERN);
    if (!match) {
      return;
    }

    textNode.replaceWith(createVimeoEmbedElement(match[1]));
  });
}

export function transformVimeoEmbedsInHtml(html: string): string {
  if (!html) {
    return html;
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll('[primevideo]').forEach((marker) => {
    replaceMarkerWithEmbed(
      marker as HTMLElement,
      (marker as HTMLElement).getAttribute('vimeoid')
    );
  });

  container.querySelectorAll('vimeo').forEach((marker) => {
    replaceMarkerWithEmbed(
      marker as HTMLElement,
      (marker as HTMLElement).getAttribute('id')
    );
  });

  transformVimeoTextNodes(container);

  return container.innerHTML;
}

export function transformVimeoEmbedsInElement(element: HTMLElement) {
  element.querySelectorAll('[primevideo]').forEach((marker) => {
    replaceMarkerWithEmbed(
      marker as HTMLElement,
      (marker as HTMLElement).getAttribute('vimeoid')
    );
  });

  element.querySelectorAll('vimeo').forEach((marker) => {
    replaceMarkerWithEmbed(
      marker as HTMLElement,
      (marker as HTMLElement).getAttribute('id')
    );
  });

  transformVimeoTextNodes(element);
}
